import { render, staticRenderFns } from "./ReminderListItem.vue?vue&type=template&id=57045bfb&scoped=true"
import script from "./ReminderListItem.vue?vue&type=script&lang=js"
export * from "./ReminderListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57045bfb",
  null
  
)

export default component.exports